
<template>
    <div class="pages-main">
		<div class="pages-section">
      		<router-view></router-view>
		</div>
		<div class="nav-main" v-if="NavShow&&navData.cusNavItems.length>0&&!$store.getters.isApp" >
			<van-tabbar v-model="Navactive" class="myTabbar" :active-color="navData.selectContentColor" :inactive-color="navData.unselectContentColor" @change="TabberChange">
				<van-tabbar-item :name="index+''" v-for="(item,index) in navData.cusNavItems" :key="index">
					<span>{{item.text}}</span>
					<template #icon>
						<svg-icon :icon-class="item.image.url" :style="'color:'+(Navactive == index?navData.selectContentColor:navData.unselectContentColor)+';'"/>
					<!-- <img :src="props.active ? icon.active : icon.inactive" /> -->
					</template>
				</van-tabbar-item>
			</van-tabbar>
		</div>
    </div>
</template>

<script>
import { NavDefault } from "@/api/user";
export default {
	data(){
		return{
			NavList:[],
			NavShow:false,
			navData:{},
			Navactive:'0',
		}
	},
	watch:{
		"$route":function(New,old){
			if(New.path!='/'&&(this.NavList.indexOf(New.path) ==-1)){
				this.NavShow = false;
			}else{
				this.Navactive = this.NavList.indexOf(New.path)+'';
				this.getNav();
			}

		}
	},
	created(){
		this.getNav();
		if(!!localStorage.getItem('NavActive')){
			this.Navactive = localStorage.getItem('NavActive');
		}else{
			console.log(this.$route.path);
		}
	},
	mounted(){
		window.onunload = function(){
			localStorage.removeItem('NavActive');
		}
	},
	destroyed(){
		localStorage.setItem('NavActive',this.Navactive);
	},
	methods:{
		async getNav(){
			let datadd = {};
			let result = await NavDefault(datadd);
			this.NavList = [];
			if(result.data.errorCode == 0){
				this.navData = result.data.data;
				result.data.data.cusNavItems.map(item=>{
					this.NavList.push(item.url.split('#')[1])
				})
				if(result.data.data.isOpened == 1){
					this.NavShow = true;
					if(this.$route.path=='/'&&(this.NavList.indexOf(this.$route.path) == -1)){
						this.Navactive = "0";
						this.NavShow = false
					}else if((this.NavList.indexOf(this.$route.path) == -1)){
						this.NavShow = false
					}
					let typeNum = 0;
					this.NavList.map((item,index)=>{
						if(item.indexOf(this.$route.path)>-1){
							typeNum ++;
							this.Navactive = index+'';
							localStorage.setItem('NavActive',index+'')
						}
					})
					if(typeNum == this.NavList.length){
						this.Navactive = "0";
					}
				}else{
					this.NavShow = false;
				}
			}else{
				this.NavShow = false;
			}
		},
		TabberChange(index){
			localStorage.setItem('NavActive',index);
			let url = this.navData.cusNavItems[index].url.split("#")[1];
			this.$router.push({
				path:url
			})
		}
	}
};
</script>
<style lang="scss" >
.pages-main{
	display: flex;
	height: 100%;
	max-width: 750px;
	margin: 0 auto;
    flex-direction: column;
	.pages-section {
		flex: 1;
		overflow: auto;
		&::-webkit-scrollbar {display:none}
		&>.personal-main{
			height: 100%;
			overflow: auto;
		}
	}
	.nav-main{
		flex: auto 0 0;

		.van-tabbar--fixed{
			position: relative;
		}
		.myTabbar{
			height: 2rem;
			.van-tabbar-item__icon{
				font-size: 0.88rem;
			}
			.van-tabbar-item__text{
				font-size: 0.48rem;
			}
		}
	}
}
</style>
